import React, { useEffect } from 'react'
import { useState } from 'react'
import { Link } from 'react-router-dom'

export function Error() {
  // יצירת כוכבים ומטאורים – נעשה זאת באמצעות useEffect
  useEffect(() => {
    const starsContainer = document.getElementById('stars')
    // יצירת 100 כוכבים
    for (let i = 0; i < 100; i++) {
      const star = document.createElement('div')
      star.className = 'star'
      star.style.left = `${Math.random() * 100}%`
      star.style.top = `${Math.random() * 100}%`
      const size = Math.random() * 3
      star.style.width = `${size}px`
      star.style.height = `${size}px`
      star.style.setProperty('--duration', `${Math.random() * 3 + 1}s`)
      starsContainer.appendChild(star)
    }

    // יצירת מטאורים
    const meteorInterval = setInterval(() => {
      const meteor = document.createElement('div')
      meteor.className = 'meteor'
      meteor.style.top = `${Math.random() * 100}%`
      meteor.style.left = '100%'
      document.body.appendChild(meteor)
      setTimeout(() => meteor.remove(), 2000)
    }, 3000)

    return () => {
      clearInterval(meteorInterval)
    }
  }, [])


  return (
    <div className="relative min-h-screen antialiased">
      {/* Stars background */}
      <div id="stars" className="fixed inset-0"></div>

      {/* Main Content */}
      <div className="error-container relative z-10 text-center">
        {/* UFO with Beam */}
        <div className="relative space-animation mb-8">

        </div>

        {/* 404 Text */}
        <h1 className="text-8xl font-bold text-white mb-4 space-animation">
          4 <span className="inline-block portal">       <img
              src="https://pub-60946b28fb374ff48942bac3163dd658.r2.dev/user-icon-default_olftzk.svg"
              alt="Astronaut"
              className="w-24 h-24 rounded-full object-cover  mx-auto astronaut-wave"
            /></span>4
        </h1>
        <p className="text-xl text-blue-200 mb-8">
          אופס! הדף שניסית לגשת אליו לא קיים.
        </p>

        {/* Interactive Elements */}
        <div className="space-y-4">


          {/* Astronaut */}
          <div className="relative inline-block space-animation">

          </div>

          {/* Action Buttons */}
          <div className="flex justify-center space-x-4 mt-8">
            <Link
              to="/"
              className="px-6 py-3 bg-primary text-white rounded-full hover:bg-red-800 transform hover:scale-105 transition"
            >
              לדף הבית
            </Link>

          </div>
        </div>


      </div>
    </div>
  )
}

export default Error
